import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeople = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "#545E6B",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M7 0C5.067 0 3.5 1.567 3.5 3.5C3.5 5.433 5.067 7 7 7C8.933 7 10.5 5.433 10.5 3.5C10.5 1.567 8.933 0 7 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M5.83333 8.16667C2.61167 8.16667 0 10.7783 0 14H14C14 10.7783 11.3883 8.16667 8.16667 8.16667H5.83333Z" })
	]
});
const ForwardRef = forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
